import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCallUs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7232_712)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M47.2239 81.9559L50.3333 82.7312L50.4707 82.6224C55.2521 78.8377 59.5928 74.5666 63.3616 69.9383L49.2547 68L49.1252 70.5911C48.9794 73.5097 48.5433 76.4827 47.8222 79.4741L47.2239 81.9559Z",
				fill: "white",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.6827 14.1239C60.5 11.294 63.5504 9 66.4959 9H90.7384C93.6839 9 95.4091 11.294 94.5918 14.1239L79.3891 66.7603C78.5718 69.5901 75.5214 71.8842 72.5759 71.8842H48.3335C45.3879 71.8842 43.6627 69.5901 44.48 66.7603L59.6827 14.1239Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.9476 12.1239C58.7649 9.29405 61.8153 7 64.7608 7H89.0032C91.9488 7 93.674 9.29405 92.8567 12.1239L77.654 64.7603C76.8367 67.5901 73.7863 69.8842 70.8408 69.8842H46.5983C43.6528 69.8842 41.9276 67.5901 42.7449 64.7603L57.9476 12.1239Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.4476 12.1239C59.1883 9.55934 61.9527 7.48037 64.6221 7.48037H88.8645C91.5339 7.48037 93.0974 9.55935 92.3567 12.1239L77.154 64.7603C76.4133 67.3248 73.6489 69.4038 70.9795 69.4038H46.7371C44.0677 69.4038 42.5042 67.3248 43.2449 64.7603L58.4476 12.1239Z",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_7232_712)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M66.7643 31.2725C66.6906 31.2536 66.5873 31.2725 66.5185 31.2348C66.376 31.1782 66.3764 31.0274 66.3964 30.8766C66.4412 30.6315 66.5057 30.3864 66.5702 30.1414C66.6845 29.6324 66.7938 29.1422 66.8834 28.652C66.8983 28.5955 66.7999 28.5955 66.785 28.652C66.5425 29.3496 66.3393 30.0471 66.1557 30.7446C66.0962 30.9709 66.0268 31.2348 66.1591 31.4045C66.2768 31.5553 66.5028 31.6684 66.7489 31.5553C66.8671 31.4799 66.897 31.2913 66.7643 31.2725Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M67.7412 32.3156C67.6276 32.523 67.0297 32.2926 66.8571 32.5C66.2963 33.5 67.001 33.4091 67.001 33.4091C66.9617 33.4091 66.9715 33.4468 67.001 33.4091C67.2125 33.4279 67.4933 33.1828 67.6314 33.032C67.8236 32.8246 67.9914 32.5607 67.9723 32.3345C67.9873 32.2025 67.7956 32.1837 67.7412 32.3156Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M68.504 29.6699C68.6022 29.7454 68.7695 29.7076 68.8829 29.5757C68.9667 29.4814 68.9867 29.3306 68.9525 29.2363C68.9036 29.1232 68.7562 29.0855 68.638 29.1609C68.5444 29.2175 68.4654 29.3683 68.4602 29.4626L68.4553 29.4814C68.4305 29.5757 68.4353 29.6322 68.504 29.6699Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M65.171 29.1799C65.0774 29.2365 65.0133 29.3307 64.9885 29.425C64.9835 29.4438 64.9736 29.4815 64.9883 29.5004C64.9784 29.5381 64.9832 29.5947 65.0126 29.6324C65.0861 29.7266 65.2878 29.7078 65.3766 29.5947C65.4604 29.5004 65.5001 29.3496 65.4609 29.2742C65.4317 29.1611 65.2842 29.1234 65.171 29.1799Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M71.9907 29.5005C72.1533 29.3308 72.4877 29.3308 72.5168 29.5193C72.5558 29.6701 72.3143 29.9152 72.5847 29.9341C72.6437 29.9341 72.7126 29.8964 72.7619 29.8587C73.0133 29.5759 72.9306 29.2177 72.6456 29.1046C72.3803 28.9915 71.9719 29.1234 71.8482 29.4439C71.8087 29.5193 71.9118 29.5759 71.9907 29.5005Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M69.5263 27.7283C69.3985 27.6906 69.2265 27.6718 69.0494 27.6718C68.9117 27.6718 68.7937 27.6718 68.6608 27.7283C68.3754 27.8414 68.2566 28.1431 68.448 28.3127C68.6688 28.5201 69.9467 28.8217 70.0564 28.1808C70.1061 27.9168 69.7475 27.7849 69.5263 27.7283Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M66.1036 27.8036C66.0005 27.7471 65.8431 27.7471 65.7005 27.7659C65.6415 27.7659 65.5628 27.7659 65.4988 27.7848C65.2725 27.8225 64.8986 27.8979 64.7948 28.143C64.5476 28.7085 65.7184 28.52 66.0041 28.3315C66.2404 28.1807 66.3149 27.8979 66.1036 27.8036Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M68.8352 24.5988C68.8304 24.5422 68.8059 24.4857 68.7815 24.4291C68.7473 24.3348 68.6884 24.2594 68.6296 24.184C68.556 24.0898 68.4825 23.9955 68.3843 23.9201C68.3792 24.0144 68.3741 24.1086 68.3886 24.2029C68.4079 24.3537 68.4414 24.7496 68.6183 24.825C68.8589 24.957 68.8497 24.693 68.8352 24.5988ZM79.2641 40.133C79.2304 39.8125 79.1721 39.5109 79.0694 39.2281C78.8936 38.7002 78.5799 38.2478 78.1874 37.8707C77.2207 36.9847 75.7463 36.6076 74.2514 36.6076C73.7596 36.6076 73.2776 36.6453 72.766 36.7207C72.3577 36.7773 71.9248 36.8527 71.5114 37.0035C71.6106 36.6265 71.6214 36.2117 71.6763 35.8535C71.7661 35.288 71.851 34.7413 71.9408 34.1757C72.0906 33.1577 72.2848 32.1208 72.356 31.1028C72.5282 31.0462 72.7054 30.9708 72.8729 30.8577C73.3703 30.5372 73.7009 30.0282 73.7365 29.5192C73.7818 29.0479 73.5566 28.6331 73.1291 28.4635C73.3519 27.8413 73.5352 27.2192 73.6989 26.5971C73.8676 25.9561 74.0609 25.2963 74.1312 24.6553C74.1964 24.1086 74.0454 23.4865 73.4457 23.3734C73.0721 23.298 72.5109 23.5619 72.3134 23.9389C71.9166 23.2791 71.1503 22.9021 70.28 22.8455C69.8179 22.8078 69.2375 22.8455 68.7942 23.1849C68.5971 23.3357 68.4492 23.5242 68.3946 23.7316C68.3896 23.7504 68.3847 23.7693 68.3944 23.807C68.6351 23.9389 68.8461 24.1086 68.9783 24.3537C69.0861 24.5422 69.1542 24.8816 68.8391 25.0324C68.4748 25.2209 68.3183 24.8439 68.2548 24.6365C68.1816 24.3914 68.1527 24.1275 68.1878 23.8447C68.119 23.807 68.0306 23.7693 67.9569 23.7504C67.6572 23.6185 67.3427 23.543 66.9838 23.4865C66.3349 23.4111 65.5529 23.4676 64.893 23.8824C64.307 24.2406 63.9172 24.825 63.9601 25.4094C63.9934 25.8807 64.2926 26.2389 64.7101 26.4463C64.4229 27.3135 64.1701 28.1995 63.9025 29.0667C63.5953 30.0848 63.2635 31.1216 63.2169 32.1208C63.1391 33.9118 64.4443 35.156 66.2732 35.3068C66.2929 35.3068 66.3322 35.3068 66.3519 35.3068C66.2332 35.6085 66.1439 35.9478 66.0645 36.2494C65.9556 36.5888 65.7974 36.9658 65.7424 37.324C65.4919 37.2297 65.2018 37.2109 64.9413 37.1543C64.6021 37.0978 64.2629 37.0412 63.8941 37.0224C63.1616 36.9658 62.3895 36.9847 61.5924 37.1732C60.2935 37.4748 59.0722 38.2289 58.0668 39.2092C57.4853 39.7748 56.9133 40.4535 56.5773 41.1321C56.4489 41.3961 56.8028 41.4715 56.9606 41.2453C57.4392 40.5477 57.8882 39.8879 58.5584 39.2846C59.1547 38.7379 59.8491 38.2666 60.5825 37.9461C61.4735 37.5502 62.3737 37.4183 63.2539 37.4371C63.7063 37.4371 64.1292 37.4748 64.5716 37.5125C64.9551 37.5502 65.3581 37.6633 65.7614 37.6256C65.9261 38.7191 67.0162 39.4354 68.2458 39.3223C68.8704 39.2658 69.5201 39.0396 70.0914 38.6625C70.377 38.474 70.648 38.2666 70.8895 38.0215C71.0768 37.833 71.3675 37.5502 71.432 37.3052C71.7567 37.2674 72.0863 37.2109 72.4159 37.1543C72.8438 37.0978 73.2865 37.0601 73.7192 37.0601C74.511 37.0412 75.278 37.1166 75.9955 37.3052C77.1357 37.6068 78.0735 38.2289 78.5334 39.2469C78.6557 39.5297 78.7484 39.8502 78.8017 40.1707C78.8358 40.3404 78.8452 40.5289 78.8399 40.6985C78.8493 40.8871 78.8144 41.0944 78.8877 41.2641C78.9367 41.3772 79.153 41.3772 79.2124 41.2264C79.3903 40.8494 79.3174 40.4535 79.2641 40.133ZM69.8365 23.2603C69.8168 23.2603 69.8365 23.2603 69.8365 23.2603C69.8168 23.2603 69.8168 23.2603 69.8365 23.2603C69.8168 23.2603 69.8168 23.2603 69.8365 23.2603ZM67.2847 25.2586C67.2994 25.2775 67.2994 25.2775 67.3141 25.2963H67.2944H67.2747C67.2797 25.2775 67.2847 25.2586 67.2847 25.2586ZM70.674 37.6445C70.462 37.8519 70.2304 38.0592 69.9891 38.2289C69.4867 38.5682 68.9158 38.7945 68.3648 38.8699C67.2089 39.0018 66.3744 38.3609 65.9682 37.5125C65.9928 37.4937 65.9978 37.4748 66.0028 37.456C66.2003 37.0789 66.2604 36.6265 66.3842 36.2306C66.3991 36.174 66.414 36.1175 66.4239 36.0798C66.6057 36.1363 66.837 36.0798 67.0239 36.0421C67.3142 35.9855 67.6144 35.8912 67.9195 35.7781C68.5101 35.5519 69.1158 35.1937 69.5889 34.7413C69.6136 34.7224 69.6185 34.7035 69.6431 34.6847C69.7123 34.5716 69.6339 34.4208 69.4666 34.4585C69.0288 34.5527 68.581 34.6847 68.1284 34.7601C67.6561 34.8355 67.1888 34.8921 66.7168 34.8921C65.8513 34.8921 65.06 34.6847 64.4563 34.2134C63.8181 33.7232 63.5051 32.9691 63.5169 32.1019C63.5289 31.1593 63.8508 30.1602 64.1235 29.1987C64.3813 28.2938 64.6341 27.4077 64.8526 26.5028C64.8869 26.5217 64.9263 26.5217 64.9803 26.5405C65.3489 26.6348 65.7473 26.616 66.1359 26.5594C66.5245 26.5028 67.0607 26.4086 67.4497 26.2012C67.5328 26.4086 67.7242 26.5783 67.9255 26.7102C68.23 26.8987 68.5986 26.993 68.987 27.0119C69.3755 27.0307 69.8183 26.9176 70.212 26.7668C70.4975 26.6537 70.8569 26.484 71.0934 26.2578C71.0483 26.6537 71.1605 27.0496 71.2728 27.37C71.4194 27.7848 71.6447 28.1995 71.9537 28.52C71.7765 28.5954 71.6337 28.6897 71.5153 28.8405C71.4858 28.8782 71.5102 28.9348 71.5545 28.9159C71.9973 28.8028 72.3567 28.6331 72.7794 28.7463C73.1627 28.8594 73.3684 29.1987 73.3429 29.5946C73.3224 29.9716 73.0609 30.3675 72.662 30.6126C72.4749 30.7257 72.2583 30.8011 72.032 30.8388C71.8304 30.8577 71.6535 30.7823 71.4616 30.8388C71.3337 30.8766 71.2842 30.9897 71.3431 31.0651C71.4508 31.2536 71.7951 31.2159 72.0214 31.1782C72.0411 31.1782 72.0608 31.1782 72.0854 31.1593C71.8372 32.1774 71.6824 33.2142 71.5128 34.2322C71.4083 34.779 71.3235 35.3257 71.2386 35.8724C71.1888 36.1363 71.1587 36.4002 71.1089 36.6642C71.084 36.8338 71.054 37.0224 71.0291 37.192C70.9403 37.3052 70.812 37.4937 70.674 37.6445ZM68.6133 24.8439C68.8589 24.957 68.8694 24.693 68.8499 24.6176C68.8451 24.5611 68.8206 24.5045 68.7962 24.448C68.762 24.3537 68.7031 24.2783 68.6443 24.2029C68.5708 24.1086 68.4972 24.0144 68.399 23.9389C68.3939 24.0332 68.3888 24.1275 68.4033 24.2217C68.403 24.3725 68.4365 24.7684 68.6133 24.8439Z",
						fill: "#6C6DCE"
					}),
					/* @__PURE__ */ _jsx("circle", {
						cx: 12,
						cy: 12,
						r: 11.5,
						transform: "matrix(1 0 -0.285354 0.958422 60.8484 19)",
						stroke: "black",
						strokeOpacity: .94
					})
				]
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 2.18182,
				rx: 1.09091,
				transform: "matrix(1 0 -0.277482 0.960731 63.6055 11)",
				fill: "black",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 13.0909,
				height: 1.09091,
				rx: .545455,
				transform: "matrix(1 0 -0.277482 0.960731 65.7515 14.7117)",
				fill: "black",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.1006 79.4009L47.6667 82.7102L32.5917 79.5078L34.3554 76.7336C34.8055 76.0257 35.1448 75.2844 35.3603 74.5383C35.7583 73.1604 35.9657 71.7884 35.9771 70.4579L36.0314 64.1361L36.1359 62.3185C36.1763 61.6165 36.3782 60.8896 36.7287 60.1845C37.4307 58.7719 38.3545 57.4149 39.4638 56.1668L50.5444 43.6997C50.8937 43.3068 51.4502 43.1583 51.8139 43.3612L52.5575 43.776C53.1453 44.1038 53.5451 44.6354 53.6969 45.291C54.1148 47.0951 53.6102 49.1962 52.3075 51.0767L47.5968 57.8768C46.2888 60.1268 45.9202 62.5376 46.5764 64.5498L46.991 65.8212C48.3526 69.9963 48.7292 74.6064 48.1006 79.4009Z",
				fill: "white",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.3254 85.8552C54.8467 84.0503 53.9904 82.4887 52.2672 82.1017L32.6601 77.6985C30.8656 77.2955 28.6474 78.2796 27.4167 80.0248L16.0001 96.2146H51.3334L54.3254 85.8552Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.8254 85.8552C54.2816 84.276 53.5323 82.9095 52.0245 82.5709L32.4174 78.1677C30.8472 77.8151 28.9062 78.6762 27.8294 80.2032L16.8773 95.7342H50.9722L53.8254 85.8552Z",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8,
				y: 95,
				width: 80,
				height: 1,
				fill: "black",
				fillOpacity: .94
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 2,
				rx: 1,
				transform: "matrix(1 0 -0.285354 0.958422 55.5708 47)",
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 1,
				rx: .5,
				transform: "matrix(1 0 -0.285354 0.958422 58.5708 51)",
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.5 22.4999C46.1455 16.6108 41.3706 11.4114 35.9 9.86852L16.3556 4.35644C11.7409 3.05497 8 5.88678 8 10.6815C8 15.8978 12.396 21.1762 17.3787 21.9428L36.714 24.9174C39.2178 25.3026 41.7568 26.1652 44.211 27.4646L49 29.9999L47.5 22.4999Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.365 29.1498L47.0318 22.4836C45.7291 16.8347 41.1481 11.8486 35.9 10.3685L16.3556 4.85644C12.0067 3.62992 8.48123 6.29864 8.48123 10.8172C8.48123 15.7331 12.624 20.7075 17.3198 21.4299L36.655 24.4046C39.2158 24.7985 41.8124 25.6807 44.3225 27.0096L48.365 29.1498Z",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.5 21.5C46.1455 15.6109 41.3706 10.4115 35.9 8.86864L16.3556 3.35656C11.7409 2.05509 8 4.8869 8 9.68159C8 14.8979 12.396 20.1763 17.3787 20.9429L35.5728 23.742C38.8137 24.2406 42.1031 25.5373 45.1839 27.5307L49 30L47.5 21.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.3687 29.0615L47.0302 21.477C45.7254 15.8309 41.146 10.8482 35.9 9.36864L16.3556 3.85656C12.0067 2.63004 8.48123 5.29876 8.48123 9.81731C8.48123 14.7332 12.624 19.7076 17.3198 20.43L35.5139 23.2291C38.8284 23.739 42.1925 25.0652 45.3434 27.104L48.3687 29.0615Z",
				stroke: "black",
				strokeOpacity: .94
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.5 20V11.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29 19V10.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 18V12.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 17V8",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31 17V13.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27 15V13.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 15.5V12.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19 14.5V11.5",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25 17V11",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M61 63C63.2091 63 65 61.2091 65 59C65 56.7909 63.2091 55 61 55C58.7909 55 57 56.7909 57 59C57 61.2091 58.7909 63 61 63ZM62.5745 61.0628L62.8268 60.2155H62.827C62.8359 60.1858 62.8329 60.1572 62.8188 60.1351C62.8046 60.1131 62.7802 60.0992 62.7503 60.0962C62.6949 60.0909 62.6507 60.0856 62.6173 60.0808C62.2849 60.0334 61.9767 59.9361 61.7033 59.7921C61.6821 59.7811 61.6551 59.7786 61.627 59.7851C61.5989 59.7916 61.5714 59.8067 61.5494 59.8278L61.0108 60.3439C60.3363 60.0278 59.8985 59.4407 59.788 58.7041L60.4375 58.3346C60.4916 58.3039 60.5242 58.2467 60.5147 58.1987C60.4545 57.8956 60.4489 57.5724 60.4981 57.2401C60.5031 57.2068 60.5109 57.1629 60.5215 57.1078C60.5272 57.0783 60.5209 57.0508 60.5038 57.0309C60.4868 57.011 60.4601 57 60.4291 57H59.5451C59.4818 57 59.414 57.023 59.3554 57.0643C59.2968 57.1057 59.2517 57.1623 59.2293 57.2228C59.1903 57.3275 59.1611 57.4131 59.1414 57.4792C58.511 59.5966 59.7908 61.3129 62 61.3129C62.069 61.3129 62.1594 61.3091 62.2708 61.3019C62.3352 61.2976 62.4024 61.2706 62.4587 61.2262C62.5151 61.1818 62.5565 61.1234 62.5745 61.0628Z",
				fill: "black",
				fillOpacity: .94
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7232_712",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_7232_712",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 12,
			transform: "matrix(1 0 -0.285354 0.958422 60.8484 19)",
			fill: "white"
		})
	})] })]
});
export default SvgCallUs;
